/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getProject = /* GraphQL */ `
  query GetProject($id: ID!) {
    getProject(id: $id) {
      id
      projectName
      identificationNumber
      abstract
      uploadAbstract
      startDate
      endDate
      projectType
      isDeleted
      status
      username
      lowerCaseName
      projectFiles {
        items {
          id
          project_id
          fileDescription
          fileLink
          username
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
      projectComments {
        items {
          id
          project_id
          fileComment
          username
          createdDate
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listProjects = /* GraphQL */ `
  query ListProjects(
    $filter: ModelProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        projectName
        identificationNumber
        abstract
        uploadAbstract
        startDate
        endDate
        projectType
        isDeleted
        status
        username
        lowerCaseName
        projectFiles {
          nextToken
        }
        projectComments {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
